<script setup>
import VisitorTable from '@/views/care-visit/visitor/VisitorTable.vue'
import VisitorRegistrationDialog from '@/views/care-visit/VisitorRegistrationDialog.vue'

definePage({
  meta: {
    name: 'visitor-management',
    subject: 'care-visit.menu',
    action: 'visitor',
  },  
})

const showVisitorRegistration = ref(false)
</script>

<template>
  <VRow>
    <VCol cols="12">
      <VisitorTable
        @register-visitor="showVisitorRegistration = true"
      />
    </VCol>
  </VRow>

  <!-- Visitor Registration Dialog -->
  <VisitorRegistrationDialog 
    v-model:isDialogOpen="showVisitorRegistration"
    @fetch-listing="fetchVisitors"
  />
</template>
